import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Channel Positioning", desc: "Platform-specific messaging that maintains brand coherence across audiences." },
  { title: "Content Programming", desc: "Editorial calendars and creative systems built for consistency and relevance." },
  { title: "Community Operations", desc: "Comment, DM, and engagement workflows that protect and amplify brand trust." },
  { title: "Paid Social Scaling", desc: "Performance media programs that convert attention into qualified demand." },
  { title: "Creator Collaboration", desc: "Partnership structures that increase credibility and social proof." },
  { title: "Performance Governance", desc: "Metric frameworks focused on contribution to pipeline, not empty reach." },
];

const SocialMedia = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Social media with"
    titleAccent="commercial intent."
    subtitle="Brand-safe social systems designed to grow audience quality, trust, and revenue impact."
    features={features}
    ctaLabel="BUILD SOCIAL ENGINE"
  />
);

export default SocialMedia;